module.exports = __webpack_public_path__ + "img/logo-order-export.98095a9b.png";